module.exports = __webpack_public_path__ + "static/media/instagram.b35f3063.svg";